import * as R from "@devexperts/remote-data-ts";
import * as stylex from "@stylexjs/stylex";
import React from "react";
import { foldRenderMode } from "../domain";
import { useDropzone, useFetchRemote } from "../hooks";
import { pipe } from "../prelude";
import { RenderException } from "./render-exception";
import { Spinner } from "./spinner";
export function withDataLoader(url, decoder, Component, minHeight) {
    return ({ renderMode })=>{
        const Loader = foldRenderMode({
            default: ()=>DataLoader,
            static: ()=>DataLoader,
            dropzone: ()=>DataLoaderWithDropzone,
            embed: ()=>DataLoader
        })(renderMode);
        return <Loader key={renderMode} url={url} decoder={decoder} minHeight={minHeight}>
        {(data)=><>
            <Component data={data} renderMode={renderMode}/>
            { /**
             * This selector is used by the screenshot service to determine if
             * the chart is ready to be captured.
             */ }
            <div data-loader-ready className="x1s85apg"/>
          </>}
      </Loader>;
    };
}
function DataLoader({ children, decoder, url, renderLoading = ()=><Spinner minHeight={minHeight}/>, renderException = (e)=>React.createElement(RenderException, {
        e
    }), minHeight }) {
    const state = useFetchRemote(url, decoder);
    return pipe(state, R.fold(renderLoading, renderLoading, (e)=>renderException(e), (x)=>children(x)));
}
function DataLoaderWithDropzone({ children, decoder, url, renderLoading = ()=><Spinner minHeight={{
        narrow: 500,
        wide: 500
    }}/>, renderException = (e)=>React.createElement(RenderException, {
        e
    }) }) {
    const state = useFetchRemote(url, decoder);
    const { dropState, getRootProps, getInputProps, isDragActive } = useDropzone(decoder);
    return pipe(state, R.fold(renderLoading, renderLoading, (e)=>renderException(e), (value)=>{
        return <>
            {pipe(dropState, R.fold(()=>children(value), ()=><div>Processing file …</div>, (e)=><ul>
                    {e.type === "InvariantViolation" ? e.message.split(",").slice(0, 20).map((x, i)=><li key={i}>{x}</li>) : <li>{JSON.stringify(e, null, 2)}</li>}
                  </ul>, (droppedData)=>children(droppedData)))}
            <div {...{
            0: {
                className: "x8rgt9n x12oqio5 xmkeg23 x1y0btm7 xf7o6q8 x1yj2zul x4fwpa6"
            },
            1: {
                className: "x8rgt9n x12oqio5 xmkeg23 x1y0btm7 xf7o6q8 x1yj2zul xl7ohfa"
            }
        }[!!isDragActive << 0]}>
              <div {...getRootProps()} className="x1n2onr6 xon2cxt">
                <input {...getInputProps()}/>
                <p>{isDragActive ? "Drop file here …" : "Upload new .json file"}</p>
              </div>
            </div>
          </>;
    }));
}
